module.exports = __webpack_public_path__ + "static/comp_front-5d143c2ec0aee56579d562446cd85ce4.jpg";